/**
 * Created by Administrator on 2017/5/24.
 */
import Vue from 'vue';
import sha512 from 'js-sha512'
import md5 from 'js-md5'

Vue.prototype.$ebqUtil = {
  clone: function (obj) {
    if (!obj) {
      return obj;
    }
    var o;
    if (obj instanceof Array) {
      o = [];
      for (var i = 0, len = obj.length; i < len; i++) {
        o.push(this.clone(obj[i]));
      }
    } else if (obj instanceof Object) {
      o = {};
      for (var j in obj) {
        o[j] = this.clone(obj[j]);
      }
    } else {
      o = obj;
    }
    return o;
  },

  parseUrlParam: function(url){
    var param = {};
    if (url.indexOf("?") >= 0) {
      url = url.split("?")[1];
      var ps = url.split("&");
      for (var i = 0; i < ps.length; i++) {
        var p = ps[i].split("=");
        param[p[0]] = p[1];
      }
    }
    return param;
  },

  isEmptyObj:function(obj){
    if(obj == null || obj == undefined){
      return true;
    }
    if(typeof obj === "object"){
      for(var i in obj){
        return false;
      }
    }
    return true;
  },

  selectArrField:function(arr, filed){
    if(!arr || !filed || (typeof filed != "string")){
      return [];
    }
    var items = [];
    if(arr instanceof Array){
      for(var i=0;i<arr.length;i++){
        let temp = arr[i];
        items.push(eval("("+"temp."+filed+")"));
      }
    }
    return items;
  },

  leftPad: function (value, size, str) {//{{ v.num|leftPad(10, '0')}}
    if(value == null || value == undefined){
      return value;
    }
    var result = "" + value;
    if(size <= result.length){
      return result;
    }
    var pad = (typeof str === "string" && str.length == 1) ? str : "0";
    for(var idx = result.length; idx < size; idx++){
      result = pad + result;
    }
    return result;
  },
    browseInfo: function () {
        var info = {};
        info.ua = window.navigator.userAgent.toLowerCase();
        if (info.ua.match(/MicroMessenger/i) == 'micromessenger') {//wechat
            info.isWechatApp = true;
        } else if (info.ua.match(/QQ/i) == "qq") {
            info.isQqApp = true;
        }
        if (/.*((android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino).*/i.test(info.ua)
            || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(info.ua)) {
            info.isMobile = true;
        }
        return info;
    },
  formatFileSize:function (value, precision) {
      if(typeof precision !== "number"){
          precision = 2;
      }
      if (value > Math.pow(1024, 5)) {
          return (value / Math.pow(1024, 5)).toFixed(precision) + "PB";
      } else if (value > Math.pow(1024, 4)) {
          return (value / Math.pow(1024, 4)).toFixed(precision) + "TB";
      } else if (value > Math.pow(1024, 3)) {
          return (value / Math.pow(1024, 3)).toFixed(precision) + "GB";
      } else if (value > Math.pow(1024, 2)) {
          return (value / Math.pow(1024, 2)).toFixed(precision) + "MB";
      } else {
          return (value / 1024).toFixed(precision) + "KB";
      }
  },
  formatFileSizeStep:function (value) {//{{v.fileSize|formatFileSize}}
      var result = "";
      if (value >= Math.pow(1024, 5)) {
          result += Math.floor((value / Math.pow(1024, 5))) + "PB ";
          value = value % Math.pow(1024, 5);
      }
      if (value >= Math.pow(1024, 4)) {
          result += Math.floor((value / Math.pow(1024, 4))) + "TB ";
          value = value % Math.pow(1024, 4);
      }
      if (value >= Math.pow(1024, 3)) {
          result += Math.floor((value / Math.pow(1024, 3))) + "GB ";
          value = value % Math.pow(1024, 3);
      }
      if (value >= Math.pow(1024, 2)) {
          result += Math.floor((value / Math.pow(1024, 2))) + "MB ";
          value = value % Math.pow(1024, 2);
      }
      if (value >= 1024) {
          result += (value / 1024).toFixed(2) + "KB";
      }
      return result;
  },
    formatDuration: function (value) {
      if (value == null || value == undefined) {
          return value
      }
      if (value >= 3600) {
          return parseInt(value / 3600) + "小时";
      } else if (value >= 60) {
          return parseInt(value / 60) + "分钟";
      }else {
          return value + "秒";
      }
  },
    encrypt(eml, pwd){
        return sha512(eml + md5(pwd));
    },
    checkCookieEnable: function () {
        return !!navigator.cookieEnabled || (alert("开启Cookie之后才能登录"), !1)
    },
}



// WEBPACK FOOTER //
// ./src/common/js/common-util.js